export const MailTrackingApiPath = {
  MAIL_CLICK: '/api/mail/click/{tracking_id}', // GET Mail Click
  MAIL_OPEN: '/api/mail/open/{tracking_id}.png', // GET Mail Open
  GET_MAIL_TRACKING_STATS: '/api/sites/{site_id}/mail-tracking/stats' // GET Get Mail Tracking Stats
}

export type MailTrackingApiPath = (typeof MailTrackingApiPath)[keyof typeof MailTrackingApiPath]

export interface MailClickVars {
  tracking_id: string
}

export interface MailOpenVars {
  tracking_id: string
}

export interface GetMailTrackingStatsVars {
  site_id: number
  spec_id?: string
}

export interface GetMailTrackingStatsResponse {
  site_id: number
  spec_id: string | null
  total_opens: number
  unique_opens: number
  total_clicks: number
  unique_clicks: number
  click_rate: number
  detail: Record<string, number>
}
